import React from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AddIcon from '@material-ui/icons/Add';
import * as DisplaySSR from '../../../data/displaySSR';
import flightDetails from '../../../containers/flightDetails';
import moment from 'moment';

const Passenger = (props) => {

  console.info("Inbound Passenger body", props);

  let { selectedFlightInfo, allFlightsData } = props
  let { paxDetails } = 'null'
  let paxSSR = []             //All the SSR pax
  let otherPax = []           //Boarded, checked in and verified pax
  // connecting pax started
  let connectingPax = []      // connecting 

  console.info("passengerinbound modal selectedFlightInfo ", selectedFlightInfo);
  console.info("passengerinbound modal allFlightsData ", allFlightsData);
  

   //Ss started      
    //   const hello = selectedFlightInfo.PassengerDetails.filter(dd=> {        
    //     return (dd.FlightNumber == parseInt(selectedFlightInfo.FltNumInbound) &&
    //     dd.ArrivalStation == 'YTZ')       
    // });

    // console.info("final list",hello);      
    //Ss ended

  //Pax groups
  let UncompletePaxUnverifiedOrCheckedIn = []      //All the non SSR pax with or without abnormal status
  let UncompletePaxUnverified = []
  let UncompletePaxUnCheckedIn = []
  let UncompletePaxUnboard = []
  let UncompletePax = []
  const displaySSR = DisplaySSR.displaySSR          // Import list of SSR



  //Get passenger information of Inbound flights started
  if (selectedFlightInfo.PassengerDetails != null) {

    paxDetails = selectedFlightInfo.PassengerDetails.filter(pax => pax.Direction == '1' && pax.Confirmed > 0)
    
    // let abc = selectedFlightInfo.ETA_Inbound;
    // console.log("8 selectedFlightInfo", abc);
     console.info("8 selectedFlightInfo whole", paxDetails);
    // Get connecting flight's passenger details
    let connecting = paxDetails.filter(pax =>     
        allFlightsData.some(
        flight=> flight.PassengerDetails.some(passenger=> {
            let result = passenger.PassengerID === pax.PassengerID && passenger.Direction === 2 && passenger.Confirmed > 0 && passenger.DepartureStation === pax.ArrivalStation;            
            if(result) {
              console.info("fg 1", passenger);
                pax.calculatedStationPair = pax.StationPair + '-' + passenger.ArrivalStation;
                pax.calFlightNumber = passenger.FlightNumber;
                pax.gatt = flight.DepGate;
                pax.carriercode = selectedFlightInfo.IATAMarketingcodeInbound               
                

                pax.OutboundEstimatedDeptTime = moment(flight.ETD_Outbound).format("HH:mm");
                console.info("7 outbound time final",pax.OutboundEstimatedDeptTime + pax.calFlightNumber);

                pax.InboundEstinatedArrivaltime = moment(selectedFlightInfo.ETA_Inbound).format("HH:mm");
                console.info("7 inbound time final",pax.InboundEstinatedArrivaltime);

                pax.remainingTime = moment.utc(moment(pax.OutboundEstimatedDeptTime, "HH:mm").diff(moment(pax.InboundEstinatedArrivaltime, "HH:mm"))).format("HH:mm");
                console.info("7 mins", pax.remainingTime );             
                
                

                // pax.remainingTime11 = moment.utc(moment("10:35", "HH:mm").diff(moment("09:47", "HH:mm"))).format("HH:mm");
                // console.info("testing", pax.remainingTime11);
             }
            return result;
        }))
    );

    console.info("conneting pax", connecting);
   
    connectingPax = connecting;    
    //Ended    
  }

  //Define passenger onboarding status: Verified passport, checked in, boarded
  function onboardStatus(pax) {

    let { verifiedStatus, checkedInStatus, boardedStatus } = ''

    verifiedStatus = pax.VerifiedTravelDocs != '' && selectedFlightInfo.TransborderOutbound ? <CheckCircleOutlineIcon /> : ''   //Verified passengers
    checkedInStatus = pax.LiftStatus == 1 ? <AddIcon /> : ''                          //Checked in passengers
    boardedStatus = pax.LiftStatus == 2 ? <span><AddIcon /><AddIcon /></span> : ''                           //Boarded passengers

    return (
      <span>{verifiedStatus}{checkedInStatus}{boardedStatus}</span>
    )
  }
  console.info("only paxDetails", paxDetails);

  //var res = str.substring(1, 4);

  //Group passengers for table manifest

  if (selectedFlightInfo.PassengerDetails != null && paxDetails.length > 0) {
    paxDetails.map(pax => {
      //Find all pax who are boarded
      if (pax.LiftStatus == 2) {
        otherPax.push(pax)                        //This include boarded SSRs, since they no longer require attention
      } else {
        if (pax.SSRDetails != null) {             //Unboarded SSRs will have attention
          pax.SSRDetails.map(ssrcode => {
            if (displaySSR.includes(ssrcode.SSRCode)) {        //Check if pax exist already when have multiple SSRs
              if (UncompletePax.includes(pax)) {
                var index = UncompletePax.indexOf(pax)
                UncompletePax.splice(index, 1)
              } else if (paxSSR.includes(pax)) {
                var index = UncompletePax.indexOf(pax)
                paxSSR.splice(index, 1)
              }
              paxSSR.push(pax)
            } else if (!paxSSR.includes(pax)) {    //Check if SSR pax has bags and other SSRs
              UncompletePax.push(pax)
            }
          })
        } else {
          UncompletePax.push(pax)
        }
      }
    })
  }

  //distinct UncompletePax - might need to check the logic for UncompletePax instead of doing a distinct  
  UncompletePax = [...new Set(UncompletePax)].filter(pax => !connectingPax.includes(pax));
  console.info("uncomplete ppppax",UncompletePax);
  //Need specific group for pax

  if (selectedFlightInfo.TransborderOutbound) {
    UncompletePaxUnverifiedOrCheckedIn = UncompletePax.filter(pax => pax.VerifiedTravelDocs == '' && pax.LiftStatus < 1)
    

    UncompletePaxUnverified = UncompletePax.filter(pax => pax.VerifiedTravelDocs == '' && pax.LiftStatus == 1)
    

    UncompletePaxUnCheckedIn = UncompletePax.filter(pax => pax.VerifiedTravelDocs != '' && pax.LiftStatus < 1)
    
    UncompletePaxUnboard = UncompletePax.filter(pax => pax.VerifiedTravelDocs != '' && pax.LiftStatus == 1)
    
  } else {
    UncompletePaxUnverifiedOrCheckedIn = UncompletePax.filter(pax => pax.LiftStatus < 1)
    
    UncompletePaxUnCheckedIn = UncompletePax.filter(pax => pax.LiftStatus == 1)
    
  } 

  


  //Decide if should show SSR code or priority number for passennger
  function getSSRCodeOrPriority(pax) {
    if (pax.SSRDetails != null) {
      let SSR = pax.SSRDetails.filter(              //Filter passengers who have SSR which is not bag
        ssrcode =>
          displaySSR.includes(ssrcode.SSRCode)
      )
      if (SSR.length > 0) {
        return SSR.map((ssrcode, i) => {
          return (<span key={ssrcode + '_' + i}>{ssrcode.SSRCode}</span>)
        })
      } else {
        return (<span>{pax.PriorityValue}</span>)
      }

    } else {
      return (<span>{pax.PriorityValue}</span>)
    }                                                                       //Any other situation return priority number

  }

  //Convert boolean to string. 0 = Unpaid, 1 = Paid
  function getSeatPaid(pax) {    
    if (pax.PaidSeatFee <= 0) {
      return 'Unpaid'
    } else {
      return 'Paid'
    }
  }
  function getSeat(pax) {
    if (pax.SeatNumber != '') {
      return pax.SeatNumber
    } else {
      return '--'
    }
  }


  function sortPaxList(typeOfPax) {
    console.info("pax details uncompleted list", typeOfPax)
    const sortedPax = [].concat(typeOfPax)
    //console.info("pax details uncompleted list 11", sortedPax)
      .sort((c, d) => (Number(c.PriorityValue) > Number(d.PriorityValue)) ? 1 : -1)
      .map((pax, i) =>      
        <TableBody key={pax.PassengerID + '_' + i}>
          <TableRow>
            <TableCell component="th" scope="row">
              <b>{pax.FirstName} {pax.LastName}</b>
            </TableCell>
            <TableCell align="center">{onboardStatus(pax)}</TableCell>
            <TableCell align="right"><b>{getSSRCodeOrPriority(pax)}</b></TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">{getSeat(pax)} ({getSeatPaid(pax)})</TableCell>
            <TableCell align="center">{pax.ProgramLevel}</TableCell>
            <TableCell align="right">{pax.calculatedStationPair ? pax.calculatedStationPair + "            / "
            +pax.carriercode+  pax.calFlightNumber  + "  /"+ pax.gatt + "/ "+pax.remainingTime : 
            pax.StationPair}            
            </TableCell>
          </TableRow>
        </TableBody>
      );
    return sortedPax
  }

  function paxListLabel(typeOfPax) {
    let theLabel = ''
    if (typeOfPax.length > 0) {
      if (typeOfPax == paxSSR) {
        theLabel = 'SSR passengers to board'
      } else if (typeOfPax == UncompletePax) {
        console.info("Non - ssr pax to board", UncompletePax)
        theLabel = "Non-SSR passengers to board"
      } else if (typeOfPax == otherPax) {
        theLabel = 'Passengers boarded'
      } else if(typeOfPax == connectingPax) {
        theLabel = 'Connecting Passengers'
      }
      return (
        <TableBody className="titleRow">
          <TableRow>
            <TableCell component="th" scope="row" colSpan="3">
              <h2>{theLabel}</h2>
            </TableCell>
          </TableRow>
        </TableBody>
      )
    }

  }
  if (paxDetails != null) {
    return (

      <Table size="small">
        {paxListLabel(paxSSR)}
        {sortPaxList(paxSSR)}
        {/* S2 started  */}
        {paxListLabel(connectingPax)}
        {sortPaxList(connectingPax)}
        {/* S2 ended  */}
        {paxListLabel(UncompletePax)}
        {sortPaxList(UncompletePax)}
        {/* {sortPaxList(UncompletePaxUnverifiedOrCheckedIn)} */}
        {/* {sortPaxList(UncompletePaxUnverified)} */}
        {/* {sortPaxList(UncompletePaxUnCheckedIn)} */}
        {/* {sortPaxList(UncompletePaxUnboard)} */}
        {paxListLabel(otherPax)}
        {sortPaxList(otherPax)}
      </Table>

    )
  } else {

    //Todo: need fallback solution

    return (
      <div>--</div>
    )
  }
}

export default Passenger